import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import Googlemap from "./Googlemap";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  CompanyID,
  isEmpty,
  isSingleSelect,
  isValidPrice,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "outletzone";
class Zoneform extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/zone/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: editID!==""? true : false,
      postdata: {
        zoneName: "",
        zoneOutletID: "",
        zoneAvailabilityID: "",
        zoneMinimumAmount: "",
        zoneFreeDelivery: "",
        zoneCoordinationPoint:[],
        zoneStatus: "",
        action:'add'
      },
      loading: true,
      availabiltyList: [],
      formpost: [],
      companyDetail: [],
      outletList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    this.loadAvailabilty();

    if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/clientpanel/zone");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var zoneStatus = result.zoneStatus == "A" ? "Active" : "In Active";
          var status =
            result.zoneStatus !== "" && result.zoneStatus !== null
              ? {
                  label: zoneStatus,
                  value: result.zoneStatus,
                }
              : "";
          const  zoneCoordinationPoint = result?.zoneCoordinationPoint ?? '';
          var clientupdatedata = {
            zoneName: result.zoneName,
            zoneOutletID: result.zoneOutletID,
            zoneAvailabilityID: result.zoneAvailabilityID,
            zoneMinimumAmount: result.zoneMinimumAmount,
            zoneFreeDelivery: result.zoneFreeDelivery,
            zoneCoordinationPoint:(zoneCoordinationPoint!=="")?JSON.parse(zoneCoordinationPoint) : null,
            zoneStatus: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/clientpanel/zone");
          showAlert("Error", "Invalid Zone", "error");
        }
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = `${apiUrl}outlet/dropDownList` ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  sateValChange = (field, value) => {
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      zoneName: postData.zoneName,
      zoneAvailabilityID: postData.zoneAvailabilityID?.value ?? '',
      zoneMinimumAmount: postData.zoneMinimumAmount,
      zoneFreeDelivery: postData.zoneFreeDelivery,
      zoneStatus: postData.zoneStatus?.value ?? "A",
      zoneOutletID:  postData.zoneOutletID?.value ?? "",
      zoneCoordinationPoint: (postData.zoneCoordinationPoint!=="")?JSON.stringify(postData.zoneCoordinationPoint):[],
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"zone"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} Zone
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/clientpanel/zone"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Form
                  {...this.props}
                  fields={this.state.postdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  availabiltyList={this.state.availabiltyList}
                  outletList={this.state.outletList}
                  editID={this.state.editID}
                  pageloading={this.state.pageloading}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Zoneform);

function validationConfig(props) {
  const {
    zoneName,
    zoneOutletID,
    zoneAvailabilityID,
    zoneMinimumAmount,
    zoneFreeDelivery,
    zoneStatus,
  } = props.fields;

  return {
    fields: [
      "zoneName",
      "zoneOutletID",
      "zoneAvailabilityID",
      "zoneMinimumAmount",
      "zoneFreeDelivery",
      "zoneStatus",
    ],

    validations: {
      zoneName: [[isEmpty, zoneName]],
      zoneAvailabilityID: [[isSingleSelect, zoneAvailabilityID]],
      zoneOutletID: [[isSingleSelect, zoneOutletID]],
      zoneMinimumAmount: [[isValidPrice, zoneMinimumAmount]],
      zoneFreeDelivery: [[isValidPrice, zoneFreeDelivery]],
      zoneStatus: [[isSingleSelect, zoneStatus]],
    },
  };
}

class Form extends Component {
  constructor(props) {
    super(props);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  sateValChange = (field, value) => {    
    if(field==='zoneCoordinationPoint') {
      this.props.onChange('zoneCoordinationPoint', value);
    }
    console.log(field, value, 'valuevaluevalue')
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgZoneName,
      errMsgAvail,
      errMsgzoneOutletID,
      errmMsgMinAmt,
      errmMsgDelivery,
      errmMsgAddDelivery,
      errmMsgFreeDelivery,
      errMsgStatus = "";
    if ($validation.zoneName.error.reason !== undefined) {
      errMsgZoneName = $validation.zoneName.show && (
        <span className="error">{$validation.zoneName.error.reason}</span>
      );
    }
    if ($validation.zoneOutletID.error.reason !== undefined) {
      errMsgzoneOutletID = $validation.zoneOutletID.show && (
        <span className="error">
          {$validation.zoneOutletID.error.reason}
        </span>
      );
    }
    if ($validation.zoneAvailabilityID.error.reason !== undefined) {
      errMsgAvail = $validation.zoneAvailabilityID.show && (
        <span className="error">
          {$validation.zoneAvailabilityID.error.reason}
        </span>
      );
    }
    if ($validation.zoneMinimumAmount.error.reason !== undefined) {
      errmMsgMinAmt = $validation.zoneMinimumAmount.show && (
        <span className="error">
          {$validation.zoneMinimumAmount.error.reason}
        </span>
      );
    }
    if ($validation.zoneFreeDelivery.error.reason !== undefined) {
      errmMsgFreeDelivery = $validation.zoneFreeDelivery.show && (
        <span className="error">
          {$validation.zoneFreeDelivery.error.reason}
        </span>
      );
    }
    if ($validation.zoneStatus.error.reason !== undefined) {
      errMsgStatus = $validation.zoneStatus.show && (
        <span className="error">{$validation.zoneStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div
            className={
              errMsgzoneOutletID !== "" &&
              errMsgzoneOutletID !== false &&
              errMsgzoneOutletID !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.zoneOutletID}
                onChange={this.handleSelectChange.bind(
                  this,
                  "zoneOutletID"
                )}
                placeholder="Select Site Location"
                options={this.props.outletList}
              />
              <label className="select-box-label">
                Site Location<span className="error">*</span>
              </label>
              {errMsgzoneOutletID}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgZoneName !== "" &&
                  errMsgZoneName !== false &&
                  errMsgZoneName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="zoneName"
                value={fields.zoneName}
                {...$field("zoneName", (e) =>
                  onChange("zoneName", e.target.value)
                )}
              />
              <label htmlFor="zoneName">
                Zone Name <span className="error">*</span>
              </label>
              {errMsgZoneName}
            </div>
          </div>
          <div
            className={
              errMsgAvail !== "" &&
              errMsgAvail !== false &&
              errMsgAvail !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.zoneAvailabilityID}
                onChange={this.handleSelectChange.bind(
                  this,
                  "zoneAvailabilityID"
                )}
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
              />
              <label className="select-box-label">
                Availabilty<span className="error">*</span>
              </label>
              {errMsgAvail}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errmMsgMinAmt !== "" &&
                  errmMsgMinAmt !== false &&
                  errmMsgMinAmt !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="zoneMinimumAmount"
                value={fields.zoneMinimumAmount}
                {...$field("zoneMinimumAmount", (e) =>
                  onChange("zoneMinimumAmount", e.target.value)
                )}
              />
              <label htmlFor="zoneMinimumAmount">Minimum Amount</label>
              {errmMsgMinAmt}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errmMsgFreeDelivery !== "" &&
                  errmMsgFreeDelivery !== false &&
                  errmMsgFreeDelivery !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="zoneFreeDelivery"
                id="zoneFreeDelivery"
                value={fields.zoneFreeDelivery}
                {...$field("zoneFreeDelivery", (e) =>
                  onChange("zoneFreeDelivery", e.target.value)
                )}
              />
              <label htmlFor="zoneFreeDelivery">Free Delivery</label>
              {errmMsgFreeDelivery}
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.zoneStatus}
                onChange={this.handleSelectChange.bind(this, "zoneStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12">
            {this.props.pageloading===false && (
            <Googlemap onShapesUpdate={this.sateValChange.bind(this)} zoneCoordinationPoint={fields.zoneCoordinationPoint} />)}
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={"/clientpanel/zone"}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
Form = validated(validationConfig)(Form);
